<mat-toolbar color="primary">
  <div class="content">
    @if (navigationAvailable()) {
      <button
        mat-icon-button
        type="button"
        class="menu-bar-hamburger-menu"
        aria-label="Navigation öffnen"
        i18n-aria-label="@@helperNavigationOpen"
        aria-controls="helper-navigation"
        aria-haspopup="dialog"
        [attr.aria-expanded]="navigationExpanded()"
        (click)="navigationToggle.emit($event)"
      >
        <mat-icon>menu</mat-icon>
      </button>
    }

    <app-menu-bar-title
      class="menu-bar-title"
      [applicationSettings]="applicationSettings$()"
      [companySettings]="companySettings$()"
      [featureConfiguration]="featureConfiguration$()"
    ></app-menu-bar-title>

    <span class="menu-spacer"></span>

    <app-join-open-appointment-button></app-join-open-appointment-button>

    <span class="menu-spacer"></span>

    <app-quota-display></app-quota-display>
    <app-notification-center></app-notification-center>
    <app-menu-bar-employee-info></app-menu-bar-employee-info>
  </div>
</mat-toolbar>
